module.exports = __webpack_public_path__ + "static/media/friends-attending-promotion-profile.12862d6c.webp";